import jsPDF from "jspdf";
import { format } from "date-fns";
import { formatarCpf } from "./CpfUtils";
import { formatarCnpj } from "./CnpjUtils";
import { aplicarMascara } from "./MaskUtils";

const listaSituacao = [
	{ label: "RASCUNHO", value: "RASCUNHO", textColor: "situacaoRascunho" },
	{ label: "PROTOCOLADA", value: "PROTOCOLADA", textColor: "situacaoProtocolada" },
	{ label: "EM ANÁLISE", value: "EM_ANALISE", textColor: "situacaoEmAnalise" },
	{ label: "PENDENTE", value: "PENDENTE", textColor: "situacaoPendente" },
	{ label: "EM ANÁLISE (RETORNO DE PENDÊNCIA)", value: "RETORNO_PENDENCIA", textColor: "situacaoRetornoPendencia" },
	{ label: "VAGA CADASTRADA", value: "CADASTRADA", textColor: "situacaoCadastrada" },
	{ label: "INDEFERIDA", value: "INDEFERIDA", textColor: "situacaoIndeferida" },
	{ label: "CANCELADA", value: "CANCELADA", textColor: "situacaoCancelada" },
	{ label: "ENCERRADA", value: "ENCERRADA", textColor: "situacaoEncerrada" },
];

const listaTipoContratacao = [
	{ label: "Aprendizagem", value: "APRENDIZAGEM" },
	{ label: "Temporária", value: "TEMPORARIA" },
	{ label: "Permanente", value: "PERMANENTE" },
	{ label: "Estágio", value: "ESTAGIO" },
];

export function gerarPDFVaga(dadosVaga, emitente) {
	const doc = new jsPDF({
		orientation: "portrait",
		unit: "mm",
		format: "a4",
	});

	let yPosition = 10;
	const pageWidth = doc.internal.pageSize.getWidth();
	const pageHeight = doc.internal.pageSize.getHeight();
	const margin = 10;
	const lineHeight = 8;
	const contentWidth = pageWidth - 2 * margin;

	const addHeader = () => {
		doc.setFontSize(10);
		doc.setFont(undefined, "bold");
		doc.text(`SOLICITAÇÃO #${dadosVaga.protocolo}`, pageWidth / 2, 12, { align: "center" });
		yPosition = 20;
		addTwoColumnField("Situação", listaSituacao.find((s) => s.value === dadosVaga.situacao).label, "Analista", dadosVaga.usuarioAnalista.nome);
		addTwoColumnField("Data de abertura", dadosVaga.dataInicio, "Data da última alteração", dadosVaga.dataAlteracao);
		addTwoColumnField("Data emissão", format(new Date(), "dd/MM/yyyy HH:mm:ss"), "Emitido por", emitente);
		doc.setLineWidth(0.5);
		doc.line(margin, yPosition, pageWidth - margin, yPosition);
		yPosition += 10;
	};

	const addSection = (title) => {
		if (yPosition + 10 > pageHeight - 15) {
			doc.addPage();
			addHeader();
		}
		doc.setFontSize(11);
		doc.setFont(undefined, "bold");
		doc.text(title, margin, yPosition);
		doc.setFont(undefined, "normal");
		yPosition += 8;
	};

	const addField = (label, value) => {
		if (yPosition + lineHeight + 2 > pageHeight - 15) {
			doc.addPage();
			addHeader();
		}
		doc.setFontSize(9);
		const halfWidth = (contentWidth - 5) / 2;
		doc.setFont(undefined, "bold");
		doc.text(`${label}`, margin, yPosition, { maxWidth: halfWidth * 0.35 });
		doc.setFont(undefined, "normal");
		doc.text(`${value}`, margin + halfWidth * 0.4, yPosition, { maxWidth: contentWidth * 0.5 });
		let lineHeightCalculated = lineHeight;
		if (
			(doc.getTextDimensions(`${label || ""}`).w > (contentWidth * 0.35)) ||
			(doc.getTextDimensions(`${value || ""}`).w > (contentWidth * 0.6))
		) {
			const ws = [
				doc.getTextDimensions(`${label || ""}`).w,
				doc.getTextDimensions(`${value || ""}`).w,
			]
			const index = ws.indexOf(Math.max(...ws));
			lineHeightCalculated = Math.ceil(ws[index] / (contentWidth * 0.35)) * lineHeight;
		}
		yPosition += lineHeightCalculated;
	};

	const addTwoColumnField = (label1, value1, label2, value2) => {
		if (yPosition + lineHeight + 2 > pageHeight - 15) {
			doc.addPage();
			addHeader();
		}
		doc.setFontSize(9);
		const halfWidth = (contentWidth - 5) / 2;

		doc.setFont(undefined, "bold");
		doc.text(`${label1}`, margin, yPosition, { maxWidth: halfWidth * 0.35 });
		doc.setFont(undefined, "normal");
		doc.text(`${value1 || ""}`, margin + halfWidth * 0.4, yPosition, { maxWidth: halfWidth * 0.6 });

		doc.setFont(undefined, "bold");
		doc.text(`${label2}`, margin + halfWidth + 5, yPosition, { maxWidth: halfWidth * 0.35 });
		doc.setFont(undefined, "normal");
		doc.text(`${value2 || ""}`, margin + halfWidth * 1.4 + 5, yPosition, { maxWidth: halfWidth * 0.6 });
		let lineHeightCalculated = lineHeight;
		if (
			(doc.getTextDimensions(`${label1 || ""}`).w > (halfWidth * 0.35)) ||
			(doc.getTextDimensions(`${value1 || ""}`).w > (halfWidth * 0.6)) ||
			(doc.getTextDimensions(`${label2 || ""}`).w > (halfWidth * 0.35)) ||
			(doc.getTextDimensions(`${value2 || ""}`).w > (halfWidth * 0.6))
		) {
			const ws = [
				doc.getTextDimensions(`${label1 || ""}`).w,
				doc.getTextDimensions(`${label2 || ""}`).w,
				doc.getTextDimensions(`${value1 || ""}`).w,
				doc.getTextDimensions(`${value2 || ""}`).w,
			]
			const index = ws.indexOf(Math.max(...ws));
			lineHeightCalculated = Math.ceil(ws[index] / (halfWidth * 0.6)) * lineHeight;
		}
		yPosition += lineHeightCalculated;
	};

	const addPageFooter = (pageNumber) => {
		doc.setFontSize(8);
		doc.text(
			`Página ${pageNumber} de 3`,
			pageWidth / 2,
			pageHeight - 5,
			{ align: "center" }
		);
	};

	// Construção do PDF

	// Página 1
	addHeader();
	addSection("Identificação do Empregador");
	addField("Tipo de Identificação", dadosVaga.empregador.tipoIdentificacao);
	addTwoColumnField(
		"Número de Identificação",
		dadosVaga.empregador.tipoIdentificacao === "CNPJ"
			? formatarCnpj(dadosVaga.empregador.numeroIdentificacao)
			: formatarCpf(dadosVaga.empregador.numeroIdentificacao),
		dadosVaga.empregador.tipoIdentificacao === "CNPJ"
			? "Razão Social"
			: "Nome",
		dadosVaga.empregador.razaoSocial
	);
	addTwoColumnField("CEP", aplicarMascara(dadosVaga.empregador.endereco.cep, "##.###-###"), "UF", dadosVaga.empregador.endereco.municipio.uf.siglaUf);
	addTwoColumnField("Município", dadosVaga.empregador.endereco.municipio.nomeCompleto, "Tipo Logradouro", dadosVaga.empregador.endereco.tipoLogradouro.descricao);
	addField("Endereço", dadosVaga.empregador.endereco.logradouro);
	addTwoColumnField("Número", dadosVaga.empregador.endereco.numero, "Bairro", dadosVaga.empregador.endereco.bairro);
	addField("Referência de Acesso", dadosVaga.empregador.endereco.referenciaAcesso || "n/a");
	yPosition += 10

	addTwoColumnField("Telefone", aplicarMascara(dadosVaga.empregador.contato.telefone, "(##) #####-####"), "Utiliza WhatsApp neste número?", dadosVaga.empregador.contato.utilizaWhatsApp === "S" ? "Sim." : "Não.");
	addTwoColumnField("E-mail", dadosVaga.empregador.contato.email, "Responsável pelo contato junto ao SINE", dadosVaga.empregador.contato.responsavelSINE);
	addTwoColumnField("Cargo", dadosVaga.empregador.cargo, "Contratação para outro CNPJ/CAEPF", dadosVaga.outroContratante === "S" ? "Sim." : "Não.");

	if (dadosVaga.outroContratante === "S" && dadosVaga.contratante) {
		addField("Tipo de Identificação", dadosVaga.contratante.tipoIdentificacao);
		addTwoColumnField(
			"Número de Identificação",
			dadosVaga.contratante.tipoIdentificacao === "CNPJ"
				? formatarCnpj(dadosVaga.contratante.numeroIdentificacao)
				: formatarCpf(dadosVaga.contratante.numeroIdentificacao),
			dadosVaga.contratante.tipoIdentificacao === "CNPJ"
				? "Razão Social"
				: "Nome",
			dadosVaga.contratante.razaoSocial
		);
	}

	addPageFooter(1);

	// Página 2
	doc.addPage();
	addHeader();

	addSection("Dados da Vaga");

	addTwoColumnField("Ocupação", dadosVaga.ocupacao, "CBO", dadosVaga.cbo);
	addTwoColumnField(
		"Número de Vagas",
		dadosVaga.numeroVagas,
		"Salário Mensal R$",
		new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(dadosVaga.salarioMensal)
	);
	addField("Descrição das Atividades", dadosVaga.descricaoAtividades);
	addTwoColumnField(
		"O endereço do local do trabalho é o mesmo da empresa?",
		dadosVaga.enderecoTrabalhoIgual === "S" ? "Sim." : "Não.",
		"Horário de Trabalho",
		dadosVaga.horarioTrabalho,
	);
	if (dadosVaga.enderecoTrabalhoIgual === "N") {
		addTwoColumnField("CEP", aplicarMascara(dadosVaga.enderecoLocalTrabalho.cep, "##.###-###"), "UF", dadosVaga.enderecoLocalTrabalho.municipio.uf.siglaUf);
		addTwoColumnField("Município", dadosVaga.enderecoLocalTrabalho.municipio.nomeCompleto, "Tipo Logradouro", dadosVaga.enderecoLocalTrabalho.tipoLogradouro.descricao);
		addField("Endereço", dadosVaga.enderecoLocalTrabalho.logradouro);
		addTwoColumnField("Número", dadosVaga.enderecoLocalTrabalho.numero, "Bairro", dadosVaga.enderecoLocalTrabalho.bairro);
		addField("Referência de Acesso", dadosVaga.enderecoLocalTrabalho.referenciaAcesso || "n/a");
		yPosition += 10
	}
	if (dadosVaga.beneficios && dadosVaga.beneficios.length) {
		let texto = dadosVaga.beneficios.map((b) => {
			if (b.complemento) {
				return `${b.tipoBeneficio.descricao} (${b.complemento}${b.tipoBeneficio.descricao !== 'Outros' ? "%" : ""})`
			}
			return b.tipoBeneficio.descricao
		}).join(", ")
		addField("Benefícios", texto);
	}
	else {
		addField("Benefícios", "n/a");
	}
	addTwoColumnField(
		"A vaga é exclusiva para PCD?",
		dadosVaga.pcd === "S" ? "Sim." : "Não.",
		"Tipo de Contratação",
		listaTipoContratacao.find((s) => s.value === dadosVaga.tipoContratacao).label,
	);
	if (dadosVaga.tipoContratacao === "APRENDIZAGEM") {
		addField("Nome da Instituição que realizará o curso de Aprendizagem", dadosVaga.curso.instituicao);
		addTwoColumnField("Nome do Curso", dadosVaga.curso.nomeCurso, "Data de início do Curso", dadosVaga.curso.dataInicioCurso);
		addTwoColumnField("Carga horária teórica semanal", dadosVaga.curso.cargaHorariaTeoricaSemanal, "Carga horária prática semanal", dadosVaga.curso.cargaHorariaPraticaSemanal);
	}
	else if (dadosVaga.tipoContratacao === "TEMPORARIA") {
		addField("Período de contratação em dias", dadosVaga.periodoContratacao);
	}
	yPosition += 2
	if (dadosVaga.motivosContratacao.length) {
		let texto = dadosVaga.motivosContratacao.map((b) => {
			return b.motivoContratacao.descricao
		}).join(", ")
		addField("Motivo da Contratação", texto);
	}
	else {
		addField("Motivo da Contratação", "n/a");
	}
	addField("Escolha a Agência FGTAS/Sine do local da vaga", dadosVaga.agencia.nome);

	addPageFooter(2);

	// Página 3
	doc.addPage();
	addHeader();

	addSection("Requisitos");
	addTwoColumnField("Experiência (meses)", dadosVaga.requisitos.experiencia.descricao, "Comprovação na CTPS?", dadosVaga.requisitos.comprovacaoCTPS === "S" ? "Sim." : "Não.");
	addTwoColumnField("Escolaridade Mínima", dadosVaga.requisitos.escolaridadeMinima.descricao, "CNH que o trabalhador deve possuir", dadosVaga.requisitos.tipoHabilitacao.descricao);
	yPosition += 4
	addField("Observações Gerais", dadosVaga.requisitos.observacoes);
	yPosition += 15

	addSection("Dados da Entrevista");
	addTwoColumnField("Responsável pela Entrevista", dadosVaga.dadosEntrevista.responsavel, "Cargo", dadosVaga.dadosEntrevista.cargo);
	if (dadosVaga.dadosEntrevista.listaDataHorario.length) {
		let texto = dadosVaga.dadosEntrevista.listaDataHorario.map((data) => {
			return `${data.dataEntrevista}, às ${data.horarioEntrevista}`
		}).join("; ")
		addField("Datas e Horários de Entrevistas", texto);
	}
	addTwoColumnField("Local da Entrevista", dadosVaga.dadosEntrevista.local, "Data para Retorno da(s) Carta(s) de Encaminhamento", dadosVaga.dadosEntrevista.dataRetorno);

	addPageFooter(3);

	doc.save(`Solicitação_${dadosVaga.protocolo}.pdf`);
};
